import { combineReducers } from '@reduxjs/toolkit';
import { getSummaryUnderwriterProfilesV2Slice, getUnderwriterProfileDetailSlice } from './slices';

export const pricingReducer = combineReducers({
  getSummaryUnderwriterProfilesV2: getSummaryUnderwriterProfilesV2Slice.reducer,
  getUnderwriterProfileDetail: getUnderwriterProfileDetailSlice.reducer,
});
